import {
    toLakh,
    sumThis,
    numberWithCommas,
    toCurrency,
    sumOf,
    countOf,
    sumAndCountOf,
    showSum,
    showCount,
    showSumAndCount,
    percentChange,
    showBlank,
    changeClassTo,
    mobileNumber,
    panCardNumber,
    validEmail,
    adharNumber,
    allDirectQueries
  } from "../commonFunctions";
  
  const maintainpassword = {
    label: "Maintain Password",
    pageLabel: "Maintain Password",
    starting: true,
    url: "maintainpassword",
    pageType: "history",
    form: [
        {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Login ID",
            name: "",
            description: "Enter Login ID" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Login ID",
            name: "LoginID",
            description: "Enter Login ID"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "User Name",
            name: "",
            description: "Enter User Name" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "User Name",
            name: "UserName",
            description: "Enter User Name"
          },
          {
            inputType: "displaytext",
            
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Defult Branch",
            name: "",
            description: "Enter Defult Branch" 
          },
          {
            inputType: "autocomplete",
            
            elementProps: {
              stayOpen: false,
              removeSelected: true,
              disabled: false,
              rtl: false
            },
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            options: [
              {
                label: "Normal",
                value: "Normal"
              },
              {
                label: "Normal",
                value: "Normal"
              }
            ],
            ajaxLoad: true,
            ajaxOptions: {
              query: {
                dialect: "mongodb",
                query: "getTDSflag",
                fieldType: "string",
                filters: ["pageData", "tdsflag"]
              },
              label: "display",
              value: "display"
            },
            placeHolder: "Defult Branch",
            name: "DefultBranch",
            description: "DefultBranch"
          },          
          
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Current Role",
            name: "",
            description: "Enter Current Role"
          },
          {
            inputType: "showdata",
            data: "HEADOFIT",
            textcolor: "black",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            }
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Old Password",
            name: "",
            description: "Enter Old Password" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Old Password",
            name: "Old_Password",
            description: "Enter Old Password"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "New Password",
            name: "",
            description: "Enter New Password" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "New Password",
            name: "New_Password",
            description: "Enter New Password"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-2",
              children: "col-sm-12"
            },
            placeHolder: "",
            label: "Repeat New Password",
            name: "",
            description: "Enter Repeat New Password" 
          },
          {
            inputType: "text",
            widths: {
              parent: "col-sm-4",
              children: "col-sm-12"
            },
            placeHolder: "Repeat New Password",
            name: "RepeatNew_Password",
            description: "Enter Repeat New Password"
          },
          {
            inputType: "displaytext",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "Validity",
            label: "Validity",
            name: "",
            description: "Validity"
          },
          {
            inputType: "date",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "ValidityFrom",
            name: "ValidityFrom",
            description: "Enter ValidityFrom"
          },
          {
            inputType: "date",
            widths: {
              parent: "col-sm-3",
              children: "col-sm-12"
            },
            placeHolder: "ValidityTo",
            name: "ValidityTo",
            description: "Enter ValidityTo"
          },

          
          
          

         
    ]
  }
  export default maintainpassword;